export default __webpack_public_path__ + "static/media/arrow-left.a0885a72.svg";